import getCombinedExercisesData from './getCombinedExercisesData'

export default function getTrainingDurationData(entry) {
  if (!entry) return null

  const exercises = getCombinedExercisesData(entry)

  const exercisesDurationList = []

  for (const key in exercises) {
    const customDurationsObj = []
    if (entry?.exerciseCustomDuration) {
      entry?.exerciseCustomDuration?.forEach((customDuration) => {
        if (parseInt(customDuration?.exercise[0].id) === parseInt(exercises[key].id)) {
          customDurationsObj[0] = customDuration.duration ? parseInt(customDuration?.duration) : 0
        }
      })
    }

    if (customDurationsObj[0]) {
      exercisesDurationList[parseInt(exercises[key].id)] = customDurationsObj[0]
    } else if (exercises[key]?.exerciseContent[0]?.exerciseDuration) {
      exercisesDurationList[parseInt(exercises[key].id)] = exercises[key]?.exerciseContent[0]?.exerciseDuration
    } else {
      exercisesDurationList[parseInt(exercises[key].id)] = 0
    }
  }

  return exercisesDurationList
}
